module.exports = __webpack_public_path__ + "static/media/banner-single-cursos.d724d217.jpg";